import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { App } from '@df/core/app';
import { SearchChangeEvent } from '@df/search/search.component.def';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { SearchComponent } from './search.component';
@Component({
    selector: 'search-modal',
    templateUrl: './search-modal.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['search-modal.scss'],
    styles: [
        `
            :host {
                display: block;
                width: 100%;
            }
        `
    ],
    standalone: true,
    imports: [SearchComponent, SizeClassDirective, CommonModule]
})
export class SearchModalComponent {
    constructor(private app: App) { }
    onFocusChange(event: SearchChangeEvent) {
        this.app.events.broadcast('search.open', this.app.client.isM || this.app.client.isS ? false : event.value);
    }
}
